export const sidePaneUIStatus = {
  showRenewPane: "SHOW_RENEW_PANE",
  showUpgradePane: "SHOW_UPGRADE_PANE",
  showChangePane:"SHOW_CHANGE_PANE",
  showInvoicePane: "SHOW_INVOICE_PANE",
  setAllOrPartialPlansFetch: "SET_ALL_OR_PARTIAL_PLANS_FETCH"
};
